import React from 'react';


export const Cognito = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/cognito.png')} />
    )
};
